export const SIGNIN_ACTION = 'userLogin';
export const CREATE_ACCOUNT_ACTION = 'createAccount';
export const RESET_PASSWORD_ACTION = 'resetPassword';
export const ROCKET_LINK_ACTION = 'rocketLink';
export const CHANGE_PASSWORD_ACTION = 'changePassword';
